export const countPageDataWidgets = (page) =>
    (page?.groups || []).reduce(
        (sum, group) => sum + (group.graphs || []).filter((graph) => graph?.type !== 'sectionTitle').length,
        0,
    );

export const countReportDataWidgets = (report) => {
    if (!Array.isArray(report)) return 0;

    return report.reduce(
        (total, section) =>
            total
            + (section.pages || []).reduce(
                (pageTotal, page) => pageTotal + (page.widgetCount ?? 0),
                0,
            ),
        0,
    );
};

export const flattenReportPages = (report) => {
    if (!Array.isArray(report)) return [];

    return report.flatMap((section) =>
        (section.pages || []).map((page) => ({
            key: `${section.id ?? 'section'}-${page.id ?? page.title}`,
            sectionTitle: section.title,
            pageTitle: page.title,
            component: page.component,
        })),
    );
};
